import React, { useState } from "react";
import {
  Box,
  Typography,
  Link,
  Button,
  TextField,
  InputAdornment,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CreateCohort from "./CreateCohort";
import { useNavigate } from "react-router-dom";
import CohortView from "./CohortView";
import ScheduledAssign from "./ScheduledAssign";
import PaginationComponent from "../../pages/brands/Pagination";

import FilledIcon from "../../../src/assests/images/plusRed.svg";


interface TaskData { task_name: string; credit_points: string; durations: string; }

export default function CohortCard() {
  const navigate = useNavigate();
  const [selectedCohortStatuses, setSelectedCohortStatuses] = useState<Record<string, string>>({});
  const [assignedCount, setassignesCount] = useState(0);
    const [cohortSchedules, setCohortSchedules] = useState<{ [key: string]: string }>({});
  const [totalCreditPoints, setTotalCreditPoints] = useState(0);
  const [totalRetailers, setTotalRetailers] = useState(0);
  const [cortView, setCortView] = useState(null); // Initialize cortView state
  const [searchTerm, setSearchTerm] = useState(""); // Initialize searchTerm state
const [unselectedIds, setUnselectedIds] = useState<number[]>([]);
const [missingidssssss, setMissingidssssss] = useState<number[]>([]);
const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]);
 const [userdatadata, setuserdatadata] = useState("");

const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [checkbaledata, setcheckbaledata] = useState([]);
  const [cohortIds, setCohortIds] = useState<string[]>([]);
const [cohortIds2, setCohortIds2] = useState<string[]>([]);
const [gettaskdata, setGetTaskData] = useState<TaskData | null>(null);

console.log(cohortIds, "cohortIds555555555555")
console.log(searchTerm, "searchTermsearchTerm44422")
  return (
    <div>
      <Box sx={{ padding: "24px 32px 0", background: "#fff " }}>
        <Link
          href="#"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
          Tasks /
          <Link
            sx={{
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "600",
              color: "rgba(142, 2, 15, 1)",
            }}
          >
            Assign Task
          </Link>
        </Link>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                marginTop: "16px",
              }}
            >
              Assign Task - Know Our Product
            </Typography>
          </Box>
          <Box sx={{ display: "flex", marginRight: "20px" }}>
            <Box sx={{ display: "flex", marginRight: "20px" }}>
              <Box sx={{}}>
                <CreateCohort
                  buttonText="Create Cohort"
                  buttonVariant="outlined"
                  buttonIcon={FilledIcon} cohorttype={""}                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ background: "#F9FBFC", marginTop: "20px" }}>
          <Box sx={{ width: "450px", paddingLeft: "20px" }}>
            <List sx={{ display: "flex" }}>
              <ListItem sx={{ paddingLeft: "0" }}>
                <label style={{ color: "#494A4B" }} htmlFor="name">
                  Points:
                </label>
                <strong id="name">300 Pts</strong>
              </ListItem>
              <ListItem sx={{ paddingLeft: "0" }}>
                <label htmlFor="name">Duration:</label>
                <strong id="name">4 Days</strong>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px;",
          }}
        >
          <TextField
            required
            placeholder="Search by Task, PMI Entity Code, Outlet Name,Location"
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={searchTerm} // Use the state variable
            onChange={(e) => setSearchTerm(e.target.value)} // Update the state
          />
            {/* <Box>
                <PaginationComponent page={0} limit={0} totalPages={0} setPage={function (page: number): void {
                    throw new Error("Function not implemented."); q
                }} />
            </Box>  */}
        </Box>
      </Box>
      <Box
        sx={{
          background: "#F9FBFC",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          padding: "20px 32px 20px",
        }}
      >
      
        {/* <CohortView 
          title="Select folder to assign the task" cohortIds={cohortIds} setCohortIds={setCohortIds} cohortIds2={[]} setCohortIds2={function (value: React.SetStateAction<string[]>): void {
            throw new Error("Function not implemented.");
          } } debouncedSearchTerm={""} searchTerm={""}       /> */}
      </Box>
      <Box sx={{ background: "#fff" }}>
        <ScheduledAssign totalCreditPoints={totalCreditPoints}
        setTotalCreditPoints={setTotalCreditPoints}
        totalRetailers={totalRetailers}
        setTotalRetailers={setTotalRetailers} cohortSchedules={cohortSchedules}
        setCohortSchedules={setCohortSchedules} userdatadata={userdatadata} selectedTaskIds={selectedTaskIds}            // ✅ pass it here
  setSelectedTaskIds={setSelectedTaskIds}   selectedCohortStatuses={selectedCohortStatuses}
      setSelectedCohortStatuses={setSelectedCohortStatuses} assignedCount={assignedCount}   gettaskdata={gettaskdata}
    setGetTaskData={setGetTaskData}
    selectedRows={selectedRows}
    setSelectedRows={setSelectedRows} missingidssssss={missingidssssss} checkbaledata={checkbaledata} unselectedIds={unselectedIds}value={""} cohortIds={[]} selectedDate1={null} setSelectedDate1={function (value: React.SetStateAction<Date | null>): void {
          throw new Error("Function not implemented.");
        } } selectedTime={null} setSelectedTime={function (value: React.SetStateAction<string | null>): void {
          throw new Error("Function not implemented.");
        } } cohorttaskid={""} selected={[]} />
      </Box>
    </div>
  );
}
